import url from './url/user_url.js'
import http from '@/utils/request'
// 获取用户信息
export const reqGetUser = (data) => http.get(url.getUser,
  {
  params:{
    ...data
  }
})